<h2>Suppression container</h2>
<p>Souhaitez-vous supprimer ce container ?</p>
<div class="btn_action">
    <button class="back" type="button" (click)="dialogRef.close()">Annuler</button>
    <button class="confirm" type="submit" (click)="deleteContainer()">Confirmer</button>
</div>